export default __webpack_public_path__ + "static/media/logo.88dd5468.png";